import * as PopoverPrimitive from '@radix-ui/react-popover';
import { cn } from '../../../lib/utils';

/* ─── Root ─── */
export const CharliePopover = PopoverPrimitive.Root;

/* ─── Trigger ─── */
export const CharliePopoverTrigger = PopoverPrimitive.Trigger;

/* ─── Anchor ─── */
export const CharliePopoverAnchor = PopoverPrimitive.Anchor;

/* ─── Content ─── */
export type CharliePopoverContentProps = React.ComponentPropsWithoutRef<
  typeof PopoverPrimitive.Content
>;

export function CharliePopoverContent({
  className,
  align = 'center',
  sideOffset = 4,
  ...props
}: CharliePopoverContentProps) {
  return (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        data-slot="popover-content"
        align={align}
        sideOffset={sideOffset}
        className={cn(
          'z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none',
          'data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95',
          'data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95',
          'data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
          className,
        )}
        {...props}
      />
    </PopoverPrimitive.Portal>
  );
}
